import axios from "axios";
import config from "./api";
import { enqueueSnackbar } from "notistack"; // ⬅ add this at the top


// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: config.backendUrl,
});

// Attach the Authorization header for every request
axiosInstance.interceptors.request.use((requestConfig) => {
  const supportToken = localStorage.getItem("supportToken");
  const token = localStorage.getItem("token"); // Get token from localStorage
  const authToken = supportToken || token;
  if (authToken) {
    requestConfig.headers.Authorization = `Bearer ${authToken}`;
  } else {
    console.warn("⚠ No token found in localStorage tokencheckgroup");
  }
  return requestConfig;
},
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response, // pass through successful responses
  (error) => {
    const statusCode = error?.response?.status;
    const isExpiredError =
      error?.response?.data?.error === "Invalid or expired token" || statusCode === 401;

    if (isExpiredError) {
      const isSupportRoute = window.location.pathname.startsWith("/support");
      const requestUrl = String(error?.config?.url || "");
      const isSupportApiCall =
        requestUrl.startsWith("/support") || requestUrl.includes("/support/");
      const isLoginOtpApiCall =
        requestUrl.includes("/user/verify-login-otp") ||
        requestUrl.includes("/user/resend-login-otp");
      const isSupportLoginApiCall = requestUrl.includes("/support/login");
      const isUserLoginApiCall = requestUrl.includes("/user/login");

      // In support pages, avoid force-logout for non-support API 401s.
      // This prevents unrelated module calls from kicking support user out.
      if (isSupportRoute && !isSupportApiCall) {
        return Promise.reject(error);
      }

      // Keep user on OTP screen for invalid/expired verification codes.
      if (isLoginOtpApiCall) {
        return Promise.reject(error);
      }

      // Keep user on support login for invalid credentials.
      if (isSupportLoginApiCall || isUserLoginApiCall) {
        return Promise.reject(error);
      }

      // Clear local storage
      localStorage.removeItem("token");
      localStorage.removeItem("supportToken");
      localStorage.removeItem("supportAllowedModules");
      localStorage.removeItem("supportSessionEnd");
      localStorage.removeItem("supportEmail");
      localStorage.removeItem("user"); // optional, if you store user info

      // Redirect to login page
      window.location.href = isSupportRoute ? "/support/login" : "/";
      enqueueSnackbar("Session Expired. Please Login.", {
        variant: "error",
      })
    }

    return Promise.reject(error);
  }
);


export default axiosInstance;